import React from 'react';

interface SpinnerIconProps {
  size?: number;
  className?: string;
}

const SpinnerIcon: React.FC<SpinnerIconProps> = ({ size = 24, className }) => (
  <svg className={className} viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
    <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" strokeOpacity="0.2" />
    <path d="M12 2 a10 10 0 0 1 10 10" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default SpinnerIcon;
